import { version } from '../../package.json';

export const config = {
  version: version,
  devPrefix: '//192.168.1.100:30106/mockApi',
  testPrefix: '//192.168.1.100:8888',
  proPrefix: '//192.168.1.100:8888',
  title: '物业',
  token: localStorage.getItem('token'),
  companyCode: 'bhszs',
  // 本地
  // appId: 'wx788346c4ec9a0a77', //wx4d2231c2233e6ec7
  // secret: '5cbc66106c22c16e9e0ec29bc5c88c9f', //e705ad7ab08b9bd988eb457411bc8c5d
  // 正式
  // appId: 'wxade2392474269258', //wx4d2231c2233e6ec7
  // secret: 'e9b8981af07f79528bc9f7787c391d68',
  //渭南正式参数
  appId: 'wx833fdee76f9f9d6a', 
  secret: 'c33733045996cee427f20b657eb8d50c',
  scope: 'snsapi_userinfo',
  state: 'STATE',
  redirect_uri: encodeURIComponent(location.origin),
};
